import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import './subnavigation-content.scss';

class SubnavigationInfo extends PureComponent {
  render() {
    const { title, subtitle, text } = this.props.content;

    return (
      <div className="subnavigation-info">
        {(!!title) &&
          <h4 dangerouslySetInnerHTML={{ __html: title }}/>
        }

        {(!!subtitle) &&
          <h2 dangerouslySetInnerHTML={{ __html: subtitle }}/>
        }

        {(!!text && text.length > 1) &&
          <div>
            {text.map((p, key) =>
              <p key={key} dangerouslySetInnerHTML={{ __html: p }} />
            )}
          </div>
        }

        {(!!text && text.length === 1) &&
          <p dangerouslySetInnerHTML={{ __html: text[0] }} />
        }
      </div>
    );
  }
}

SubnavigationInfo.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    text: PropTypes.arrayOf(PropTypes.string)
  })
};

class SubnavigationLinks  extends PureComponent {
  render() {
    return (
      <ul className="subnavigation-links">
        {this.props.links.map((link, key) =>
          <li key={key}>
            <Link
              to={link.pathname}
              activeClassName="subnavigation-links-active"
              dangerouslySetInnerHTML={{ __html: link.title}}
            />
          </li>
        )}
      </ul>
    );
  }
}

SubnavigationLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      pathname: PropTypes.string,
      title: PropTypes.string
    })
  )
};

class SubnavigationContent extends PureComponent {
  render() {
    return (
      <div className="container">
        <div className="subnavigation-row">
          <div className="subnavigation-col">
            <SubnavigationLinks links={this.props.activeTab.links} />
          </div>

          {(this.props.activeTab.content && !this.props.isMobile) &&
            <div className="subnavigation-col">
              <SubnavigationInfo content={this.props.activeTab.content}/>
            </div>
          }
        </div>
      </div>
    );
  }
}

SubnavigationContent.propTypes = {
  activeTab: PropTypes.shape({
    links: PropTypes.arrayOf(PropTypes.object),
    content: PropTypes.object
  }),
  isMobile: PropTypes.bool
};

export default SubnavigationContent;



// WEBPACK FOOTER //
// ./src/components/Subnavigation/SubnavigationContent.js